var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnique = function SvgUnique(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101,
    height: 101,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "unique_svg__a",
    width: 101,
    height: 101,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 3,
    d: "M99.5 99.167V1.5H1.833v97.667z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    mask: "url(#unique_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#unique_svg__b)",
    d: "M74.02 74.117h12.23c6.518 0 11.8 5.283 11.8 11.8v0c0 6.517-5.282 11.8-11.8 11.8H15.084c-6.517 0-11.8-5.283-11.8-11.8v0c0-6.517 5.283-11.8 11.8-11.8h33.115"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#unique_svg__c)",
    d: "M61.011 85.361 10.722 35.072 42.845 2.95l50.29 50.29z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#unique_svg__d)",
    d: "m57.672 49.9 3.33 35.452-50.27-50.27 35.452 3.33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#unique_svg__e)",
    d: "M93.125 53.229 47.17 48.914 42.855 2.959z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unique_svg__b",
    x1: -17.025,
    x2: 108.205,
    y1: 81.703,
    y2: 81.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unique_svg__c",
    x1: -6.938,
    x2: 101.964,
    y1: 29.439,
    y2: 29.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unique_svg__d",
    x1: -0.04,
    x2: 66.388,
    y1: 51.24,
    y2: 51.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "unique_svg__e",
    x1: 32.083,
    x2: 98.511,
    y1: 19.117,
    y2: 19.117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED5C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F28230"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331"
  })))));
};
export default SvgUnique;